<template>
  <div class="page-footer">
    <div style="width: 1000px; height: 100%; margin-left: auto; margin-right: auto;
                display: flex; justify-content: center; align-items: center;">
      <div class="footer-text" style="user-select: none">WonderFlow</div>
      <div style="display: block; margin-left: auto;">
        Narration-Centric Design of Animated Data Videos
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageFooter',
  components: {},
  data() {
    return {}
  },
  methods: {
  },
  mounted() {
  },
  computed: {}
}
</script>

<style scoped>
.page-footer {
  width: 100%;
  height: 100%;
}

.footer-text {
  font-size: 1.7em;
  font-weight: bold;
  font-family: 'Courier New', Courier, monospace;
  color: #9b9b9b;
}
</style>
